import { render } from "./B2D.vue?vue&type=template&id=70fc51a4"
import script from "./B2D.vue?vue&type=script&lang=js"
export * from "./B2D.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__